// spinner.component.ts
import { Component, inject } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { LoadingService } from '@/app/core/services/loading.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [TegelModule, CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  private loadingService = inject(LoadingService);

  isLoading = this.loadingService.loading;
  progress = this.loadingService.progress;
  message = this.loadingService.message;
  status = this.loadingService.status;
  
  // 计算显示的文本
  get displayMessage(): string {
    const currentMessage = this.message();
    const currentStatus = this.status();
    
    // 根据状态添加前缀
    if (currentStatus === 'init') {
      return `Initializing: ${currentMessage}`;
    } else if (currentStatus === 'upload') {
      return `Uploading: ${currentMessage}`;
    } else if (currentStatus === 'complete') {
      return `Completing: ${currentMessage}`;
    } else if (currentStatus === 'checking') {
      return `Checking: ${currentMessage}`;
    }
    
    return currentMessage;
  }
}